import { jobProfileKpisDelete, jobProfileKpisGet } from "#job-profile/services/api"
import JobProfileItem from "../JobProfileItem"
import { JobProfileKpisFormDialog } from "./JobProfileKpisForm"

export default function JobProfileKpis({ profileId, autoFetch, noEdit }) {
	const items = [
		{
			name: "name",
			label: "Nombre",
			props: {},
		},
		{
			name: "description",
			label: "Description",
		},
		{
			name: "minimum_percentage",
			label: "% Mínimo",
		},
	]
	return (
		<JobProfileItem
			key="kpis"
			{...{
				profileId,
				autoFetch,
				tableItems: items,
				apiGet: jobProfileKpisGet,
				apiDelete: jobProfileKpisDelete,
				name: "",
				messageDelete: (responsibility) => (
					<span>
						¿Estas seguro de eliminar el kpi
						<strong> {responsibility.name}</strong>?
					</span>
				),
				AddForm: JobProfileKpisFormDialog,
				noEdit,
			}}
		/>
	)
}
